import { configureStore } from '@reduxjs/toolkit'
import userReducer from './redux/userSlice'
import jobsReducer from './redux/jobSlice'
import tasksReducer from './redux/taskSlice'
import eventsReducer from './redux/eventSlice'
import requestsReducer from './redux/requestSlice'
import logger from 'redux-logger';
export default configureStore({
  reducer: {
    user: userReducer,
    jobs: jobsReducer,
    tasks: tasksReducer,
    events: eventsReducer,
    requests: requestsReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger)
})